export const ACT_LOADDATA = 'loadData';
export const ACT_LOADADMINDATA = 'loadAdminData';

export const GET_MODULESTARIFFS = 'getModulesTariffs';
export const GET_ADMINMODULESTARIFFS = 'getAdminModulesTariffs';
export const GET_USERMODULES = 'getUserModules';
export const GET_ADMINUSERMODULES = 'getAdminUserModules';

export const MUT_DATASAVE = 'saveData';
export const MUT_ADMINDATASAVE = 'saveAdminData';
export const MUT_ADMINDATACLEAR = 'clearAdminData';
